export default __webpack_public_path__ + "images/afe83c9e74a5c46f1a4381cd5b5d26cc-arts.webp";